import {Component, ElementRef, Inject, OnInit} from "@angular/core";
import {NgbActiveModal, NgbModalRef, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormGroup, FormControl, FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import * as jQuery from "jquery";
import {DataService} from "../../../services/data/data.service";
import {LoginRequestModel} from "../../../model/login.request.data";
import {CookiesService} from "../../../tools/cookies.service";
import {TradeRequestModel} from "../../../model/trade.request.data";
import {Subscription} from "rxjs";
import {LoginRs} from "../../../interfaces/service.response";

import * as $ from "jquery";
import {WorkspaceServiceService} from "../../../services/workspace-service.service";
import {_} from "ag-grid";
import {waitForMap} from "@angular/router/src/utils/collection";
import {Utils} from "../../../utils";
import {UserType} from "../../../enums/USerType.enum";
import { Providers } from '../../../enums/providers';

declare function myMethod(): any;
export declare var fbq: Function;

@Component({
    selector: "modal-login-provider",
    template: require('./login-provider.component.html'),
    styles: [require('./login-provider.component.css')]
})
export class LoginProviderModal implements OnInit {
    form!: FormGroup;
    protected subscription!: Subscription;

    constructor(
        protected router: Router,
        protected fb: FormBuilder,
        public activeModal: NgbActiveModal,
        protected modalService: NgbModal,
        protected dataService: DataService,
        public workspaceService: WorkspaceServiceService
    ) {

        this.form = this.fb.group({
            Username: [this.userName, Validators.required],
            Password: [this.userPassword, Validators.required],

        });

        if(this.userPassword && this.userPassword!="")
        {
            this.remember = true;
        }

        this.form.controls["Username"].setValue(this.userName);
        this.form.controls["Password"].setValue(this.userPassword);
    }

    ngOnInit()
    {
        this.form.controls["Username"].setValue(this.userName);
        this.form.controls["Password"].setValue(this.userPassword);
         this.validateAllFormFields(this.form);
         if(this.userPassword && this.userPassword!="")
         {
             this.remember = true;
         }
    }


    private _disableSubmitButton: boolean = false;
    public get disableSubmitButton(): boolean {
        return this._disableSubmitButton;
    }
    public set disableSubmitButton(value: boolean) {
        this._disableSubmitButton = value;
    }


    private _loginError: boolean = false;
    public get loginError(): boolean {
        return this._loginError;
    }
    public set loginError(value: boolean) {
        this._loginError = value;
    }

    private _userName: string = "";
    public get userName(): string {
        return this._userName;
    }
    public set userName(value: string) {
        this._userName = value;
    }

   private _userPassword: string | null = "";
    public get userPassword(): string | null {
        return this._userPassword;
    }
    public set userPassword(value: string | null) {
        this._userPassword = value;
    }

    private _Provider: string = Providers.GAIN;
    public get Provider(): string {
        return this._Provider;
    }
    public set Provider(value: string) {
        this._Provider = value;
    }


    private _canAdd: boolean = false;
    public get canAdd(): boolean {
        return this._canAdd;
    }
    public set canAdd(value: boolean) {
        this._canAdd = value;
    }


    private _canUpdate: boolean = false;
    public get canUpdate(): boolean {
        return this._canUpdate;
    }
    public set canUpdate(value: boolean) {
        this._canUpdate = value;
    }


    private _errorMessage: string = "";
    public get errorMessage(): string {
        return this._errorMessage;
    }
    public set errorMessage(value: string) {
        this._errorMessage = value;
    }
    onSubmit() {

        if(this.form.valid) {
            console.log("GAIN LOGIn ACTION");
            this.disableSubmitButton = true;

            this.workspaceService.GainService.LogOn(this.form.controls["Username"].value, this.form.controls["Password"].value).then(v => {
                console.log(v);
                this.disableSubmitButton = true;
                this.workspaceService.data.gainLoginResponse = v;
                let userPassToRemeber = "";

                if(this.remember)
                {
                    userPassToRemeber = this.form.controls["Password"].value;
                }

                if(this.canAdd)
                {
                    this.workspaceService.data.AddProviderLoginData(this.workspaceService.data.userId, Providers.GAIN, this.form.controls["Username"].value, userPassToRemeber );
                }

                if(this.canUpdate)
                {
                    this.workspaceService.data.UpdateProviderLoginData(this.workspaceService.data.userId, this.form.controls["Username"].value, userPassToRemeber, Providers.GAIN );
                }
                
                this.activeModal.dismiss();

            }).catch(v => {
                 this.loginError = true;

                 if(v.Error)
                { this.errorMessage = v.Error;}
                else
                {
                    this.errorMessage="Service Error";
                }

                this.disableSubmitButton = false;
            })



        }
    }

    getFormControl(name: string) {
        return this.form.get(name);
    }

    // returns TRUE if the FormControl is valid
    isValid(name: string) {
        var e = this.getFormControl(name);
        return e && e.valid;
    }

    // returns TRUE if the FormControl has been changed
    isChanged(name: string) {
        var e = this.getFormControl(name);
        return e && (e.dirty || e.touched);
    }

    // returns TRUE if the FormControl is invalid after user changes
    hasError(name: string) {
        var e = this.getFormControl(name);
        return e && (e.dirty || e.touched) && !e.valid;
    }

    public isRemember() {
        this.remember = !this.remember;
    }

    private _remember: boolean = false;
    public get remember(): boolean {
        return this._remember;
    }
    public set remember(value: boolean) {
        this._remember = value;
    }
    
    public runDoShortcut() {
        myMethod();
    }

    public onKey(event: any) {
        if(event.code == "Space" || event.cod == "Enter") {
            this.isRemember();
        }
    }

    public Providers = Providers;

    public get debugVisibility() {
        return this.dataService.DebugVisibility;
    }

    private _accountPrefix: string = "";
    public get accountPrefix(): string {
        return this._accountPrefix;
    }
    public set accountPrefix(value: string) {
        this._accountPrefix = value;
    }


    validateAllFormFields(formGroup: FormGroup) {         //{1}
  Object.keys(formGroup.controls).forEach(field => {  //{2}
    const control = formGroup.get(field);             //{3}
    if (control instanceof FormControl) {             //{4}
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {        //{5}
      this.validateAllFormFields(control);            //{6}
    }
  });
}
}
